import React from 'react';

export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  tone = 'burgundy',
  align = 'center',
  onDark = false,
  style = {},
}) {
  const toneColor = {
    burgundy: 'var(--burgundy-700)',
    navy: 'var(--navy-800)',
    tan: 'var(--tan-700)',
  };
  const headingColor = onDark ? 'var(--white)' : toneColor[tone];
  const eyebrowColor = onDark ? 'var(--tan-200)' : 'var(--tan-600)';
  const subColor = onDark ? 'rgba(255,255,255,0.85)' : 'var(--text-body)';
  const isCenter = align === 'center';

  return (
    <header style={{ textAlign: align, maxWidth: '760px', margin: isCenter ? '0 auto' : '0', ...style }}>
      {eyebrow && (
        <div style={{ fontFamily: 'var(--font-ui)', fontSize: '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.14em', color: eyebrowColor, marginBottom: '10px' }}>
          {eyebrow}
        </div>
      )}
      <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: 'clamp(32px, 4vw, 42px)', fontWeight: 500, lineHeight: 1.12, color: headingColor, margin: 0 }}>
        {title}
      </h2>
      <div style={{ width: '80px', height: '4px', borderRadius: '2px', background: 'var(--gradient-accent)', margin: isCenter ? '20px auto 0' : '20px 0 0' }} />
      {subtitle && (
        <p style={{ fontFamily: 'var(--font-ui)', fontSize: '18px', lineHeight: 1.6, color: subColor, margin: '20px 0 0' }}>
          {subtitle}
        </p>
      )}
    </header>
  );
}
